import { observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { hasRunFinished } from './ImportRunDetails.utils';

interface IUnreadableCellsLineProps {
  importer: Importer;
}

/** "3 cells couldn't be read and were left empty." Nothing for 0, and for an import that predates the count. */
function UnreadableCellsLine({
  importer,
}: Readonly<IUnreadableCellsLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const count = importer.get('unreadable_cells') ?? 0;
  if (!hasRunFinished(importer) || count <= 0) {
    return null;
  }

  return (
    <Text.DefaultRegular>
      {t("{{formattedCount}} cells couldn't be read and were left empty.", {
        count,
        formattedCount: numeral(count).format('0,0'),
      })}
    </Text.DefaultRegular>
  );
}

export default observer(UnreadableCellsLine);
